<template>
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" style="enable-background:new 0 0 24 24" viewBox="0 0 24 24"><path fill="currentColor" d="M-42.5-85.3h4.4l1.2 5.3h18l-2.6 12H-37l-3.3-14.7h-2.3v-2.6zm20.4 8h-14.1l1.5 6.7h11.2l1.4-6.7zm-11.7 16c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm9.3 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z" style="fill-rule:evenodd;clip-rule:evenodd" transform="translate(42.667 85.333)"/></svg>
</template>

<script>
  export default {
    name: "CartIcon"
  }
</script>